import { render, staticRenderFns } from "./DividendsSlip.vue?vue&type=template&id=0de5778e"
import script from "./DividendsSlip.vue?vue&type=script&lang=js"
export * from "./DividendsSlip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports